// =============================================================================
// MATRICE "Dimensione della catena del valore" — Reale Group 2025 (pag. 83)
// Fonte: _design/Dimensione catena del valore.pdf
// Destinazione: popup "Analisi integrata ESG e linee strategiche di Gruppo"
//               (riusando il meccanismo scroll-table di sezione-5-Analisi.js)
//
// ⚠️ BOZZA DA VERIFICARE — trascrizione visiva dal PDF. Le celle marcate (?)
//    in fondo vanno ricontrollate prima di pubblicare (dato di bilancio).
//
// Legenda icone:
//   P = Positivo (faccina verde)   N = Negativo (faccina rossa)
//   O = Opportunità (sole blu)     R = Rischio  (triangolo blu)
//   []   = cella vuota
//   "NA" = "non applicabile" (copre Impact+Financial di quella dimensione)
//
// Ogni dimensione ha { impact: [...], financial: [...] } oppure "NA".
// =============================================================================

export const DIMENSIONI = [
  { key: "fornitori",         label: "Fornitori",          banda: "UPSTREAM" },
  { key: "operazioniProprie", label: "Operazioni proprie", banda: "MIDSTREAM" },
  { key: "sottoscrizione",    label: "Sottoscrizione",     banda: "DOWNSTREAM" },
  { key: "credito",           label: "Credito",            banda: "DOWNSTREAM" },
  { key: "investimenti",      label: "Investimenti",       banda: "DOWNSTREAM" },
  { key: "distributori",      label: "Distributori",       banda: "DOWNSTREAM" },
];

export const LEGENDA = {
  P: "Positivo",
  N: "Negativo",
  O: "Opportunità",
  R: "Rischio",
};

// Righe: tema ESRS -> sottotemi, ciascuno con le 6 dimensioni
export const MATRICE = [
  {
    tema: "ESRS E1 — Cambiamenti climatici",
    sottotemi: [
      {
        sottotema: "Mitigazione dei cambiamenti climatici",
        celle: {
          fornitori:         { impact: ["N"],      financial: [] },
          operazioniProprie: { impact: ["N", "P"], financial: ["R"] },
          sottoscrizione:    { impact: ["N", "P"], financial: ["R"] },
          credito:           { impact: ["N"],      financial: ["R"] },
          investimenti:      { impact: ["N", "P"], financial: ["R"] },
          distributori:      { impact: [],         financial: [] },
        },
      },
      {
        sottotema: "Adattamento ai cambiamenti climatici",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: ["N", "P"], financial: ["R"] },
          sottoscrizione:    { impact: ["N"], financial: ["R"] },
          credito:           { impact: ["N"], financial: ["R"] },
          investimenti:      { impact: [],    financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS E4 — Biodiversità ed ecosistemi",
    sottotemi: [
      {
        sottotema: "(tema unico)",
        celle: {
          fornitori:         { impact: ["N"], financial: [] },
          operazioniProprie: { impact: [], financial: [] },
          sottoscrizione:    { impact: ["N"], financial: [] },
          credito:           { impact: ["N"], financial: [] },
          investimenti:      { impact: ["N"], financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS S1 — Forza lavoro propria",
    sottotemi: [
      {
        sottotema: "Condizioni di lavoro",
        celle: {
          fornitori:         "NA",
          operazioniProprie: { impact: ["N", "P"], financial: ["N", "O"] },
          sottoscrizione:    "NA",
          credito:           "NA",
          investimenti:      "NA",
          distributori:      "NA",
        },
      },
      {
        sottotema: "Parità di trattamento e di opportunità per tutti",
        celle: {
          fornitori:         "NA",
          operazioniProprie: { impact: ["N", "P"], financial: ["R"] },
          sottoscrizione:    "NA",
          credito:           "NA",
          investimenti:      "NA",
          distributori:      "NA",
        },
      },
    ],
  },
  {
    tema: "ESRS S2 — Lavoratori nella catena del valore",
    sottotemi: [
      {
        sottotema: "Condizioni di lavoro",
        celle: {
          fornitori:         { impact: ["N"],      financial: ["R"] },
          operazioniProprie: "NA",
          sottoscrizione:    { impact: ["N"],      financial: ["R"] },
          credito:           { impact: ["N"],      financial: ["R"] },
          investimenti:      { impact: ["N", "P"], financial: ["R"] },
          distributori:      { impact: [],         financial: [] },
        },
      },
      {
        sottotema: "Parità di trattamento e di opportunità per tutti",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: "NA",
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: ["N"], financial: ["R"] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS S3 — Comunità interessate",
    sottotemi: [
      {
        sottotema: "Diritti economici, sociali e culturali delle comunità",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: ["P"], financial: [] },
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: [],    financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS S4 — Consumatori e utilizzatori finali",
    sottotemi: [
      {
        sottotema: "Impatti legati alle informazioni per i consumatori e/o per gli utilizzatori finali",
        celle: {
          fornitori:         { impact: ["N"], financial: [] },
          operazioniProprie: { impact: ["N"], financial: ["R"] },
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: ["N"], financial: ["R"] }, // (?)
          distributori:      { impact: ["N"], financial: ["R"] }, // (?)
        },
      },
      {
        sottotema: "Inclusione sociale dei consumatori e/o degli utilizzatori finali",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: ["N"], financial: ["R"] },
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: [],    financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
    ],
  },
  {
    tema: "ESRS G1 — Condotta delle imprese",
    sottotemi: [
      {
        sottotema: "Cultura d'impresa",
        celle: {
          fornitori:         "NA",
          operazioniProprie: { impact: ["N", "P"], financial: ["R"] },
          sottoscrizione:    "NA",
          credito:           "NA",
          investimenti:      "NA",
          distributori:      "NA",
        },
      },
      {
        sottotema: "Protezione degli informatori",
        celle: {
          fornitori:         { impact: [], financial: [] },
          operazioniProprie: { impact: [], financial: ["R"] },
          sottoscrizione:    { impact: [], financial: [] },
          credito:           { impact: [], financial: [] },
          investimenti:      { impact: [], financial: [] },
          distributori:      { impact: [], financial: [] },
        },
      },
      {
        sottotema: "Gestione dei rapporti con i fornitori, comprese le prassi di pagamento",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: [],    financial: [] },
          sottoscrizione:    { impact: ["N"], financial: [] }, // (?) colonna da confermare
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: [],    financial: [] },
          distributori:      { impact: [],    financial: [] },
        },
      },
      {
        sottotema: "Corruzione attiva e passiva",
        celle: {
          fornitori:         { impact: [],    financial: [] },
          operazioniProprie: { impact: [],    financial: ["R"] },
          sottoscrizione:    { impact: [],    financial: [] },
          credito:           { impact: [],    financial: [] },
          investimenti:      { impact: ["N"], financial: ["R"] }, // (?)
          distributori:      { impact: ["N"], financial: ["R"] }, // (?)
        },
      },
    ],
  },
];
